import { render } from "./TransferAcpPlan.vue?vue&type=template&id=4f139245&scoped=true"
import script from "./TransferAcpPlan.vue?vue&type=script&lang=js"
export * from "./TransferAcpPlan.vue?vue&type=script&lang=js"

import "./TransferAcpPlan.vue?vue&type=style&index=0&id=4f139245&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f139245"]])

export default __exports__